import { CustomerContract } from "..//domain/contracts/customer_contract";
import { customerEntity } from '../domain/entities/customer_entity';
import { customerIndexEntity } from "../domain/entities/customer_index_entity";
import { customerShowEntity } from "../domain/entities/customer_show_entity";
import http from "../../../plugins/http-common"
import i18n from "../../../i18n"

export const HttpCustomerRepository = {
  ...CustomerContract,
  model: customerEntity,
  model_index: customerIndexEntity,
  model_show: customerShowEntity,

  async index(is_national, page, per_page, search, sort_by) {
    var sort = ""
    if (sort_by.length > 0) sort = '&sort=' + sort_by[0].field + '&sort_direction=' + sort_by[0].direction;

    var pp = ""
    if (per_page != null) '&per_page=' + per_page;

    const res = await http.get('clientsIndex/' + is_national + '?page=' + page + pp + '&search=' + search + sort);

    for(let i = 0; i < res.data.data.length; i++) {
      res.data.data[i] = res.data.data[i].attributes;

      res.data.data[i].actions = JSON.parse(JSON.stringify([
        {
            name: i18n.t('customers.details'),
            icon: {
                color: 'accent',
                icon: 'info'
            },
            link: 'customers/details/' + res.data.data[i].id,
            permission: "client.show"
        },
        {
            name: i18n.t('customers.edit'),
            icon: {
                color: 'accent',
                icon: 'edit'
            },
            link: 'customers/edit/' + res.data.data[i].id,
            permission: "client.update"
        },
        {
            name: i18n.t('customers.edit_fees'),
            icon: {
                color: 'accent',
                icon: 'add_card'
            },
            link: 'customers/edit/fees/' + res.data.data[i].id,
            permission: "customer_fees.create"
        },
        {
            name: i18n.t('customers.manage_shops'),
            icon: {
                color: 'accent',
                icon: 'shopping_cart'
            },
            link: 'customers/manage_stores/' + res.data.data[i].id,
            permission: "client.manage_stores"
        },
        {
            name: i18n.t('customers.edit_guides_fees'),
            icon: {
                color: 'accent',
                icon: 'local_offer'
            },
            link: 'customers/edit/guides_fees/' + res.data.data[i].id,
            permission: "guides_fees.create"
        },
      ]));

      if (!res.data.data[i].guides_service) res.data.data[i].actions.pop();
      res.data.data[i].parameters = res.data.data[i].id;
    }

    return res;
  },

  async create(data) {
    const res = await http.post('clients', data);

    return res; 
  },
  
  async edit(customer_id, data) {
    const res = await http.put('clients/' + customer_id, data);

    return res; 
  },

  async create_smart_values(customer_id, values) {
    const res = await http.post('smart-carrier/client-preferences?client_id=' + customer_id, values);
    
    return res;
  },

  async get_smart_values(customer_id) {
    const res = await http.get('smart-carrier/client-preferences?client_id=' + customer_id);
    
    return res;
  },

  async show(id) {
    const res = await http.get(`clients/${id}`);

    return res;
  }
};